<template>
  <div class="newTicket">
    <Header
      :showOperation="false"
      :showHome="false"
      showBack
      @back="$router.go(-1)"
    />

    <div class="content">
      <div class="content-title">{{ stringList.NewTicket }}</div>

      <a-form :form="form" @submit="handleSubmit">
        <a-form-item class="formItem">
          <a-select
            disabled
            show-search
            size="large"
            dropdownClassName="num-drop"
            :placeholder="stringList.EnterRoom"
            v-decorator="[
              'roomNumber',
              {
                initialValue: roomNumber,
                rules: [{ required: true, message: stringList.invalid_room }],
              },
            ]"
          >
            <a-select-option
              v-for="item in roomArray"
              :key="item.id"
              :value="item.name"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item class="formItem" v-if="!showAddSpecial">
          <a-select
            :defaultActiveFirstOption="false"
            allowClear
            show-search
            :filter-option="(input, option) => true"
            size="large"
            dropdownClassName="num-drop"
            :placeholder="stringList.TypeSelectItem"
            v-decorator="[
              'serviceKey',
              {
                rules: [
                  { required: true, message: stringList.InvalidTypeSelectItem },
                ],
              },
            ]"
            @search="remoteMethod"
            @change="changeServiceKey"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option
              v-for="item in serviceOptions"
              :key="item.id"
              :value="item.keyword"
            >
              {{ item[language] || item["keyword"] }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item class="formItem" v-else>
          <a-textarea
            v-decorator="[
              'serviceKey',
              {
                rules: [{ required: true, message: ' ' }],
              },
            ]"
            :placeholder="stringList.SpecialRequest100"
            :auto-size="{ minRows: 3, maxRows: 5 }"
            @input="checkInput"
          />
          <div class="error-message">{{ serviceKeyErrorMessage }}</div>
        </a-form-item>

        <div class="RequestCheck row">
          <a-checkbox @change="onChange">
            {{ stringList.SpecialRequest }}
          </a-checkbox>
        </div>

        <a-form-item class="formItem">
          <a-select
            show-search
            size="large"
            dropdownClassName="num-drop"
            :placeholder="stringList.Department"
            v-decorator="[
              'hotelDeptId',
              {
                rules: [
                  { required: true, message: stringList.InvalidDepartment },
                ],
              },
            ]"
          >
            <a-select-option
              v-for="item in departAll"
              :key="item.hotelDeptId"
              :value="item.hotelDeptId"
            >
              {{ item[language] }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <div class="comments">
          <div class="addBtn row" v-if="!addTime" @click="addTimes">
            <svg-icon
              iconClass="add2"
              style="width: 15px; height: 15px"
            ></svg-icon>
            <span>{{ stringList.TimePreference }}</span>
          </div>
          <div v-else>
            <a-date-picker
              format="MM/DD/YY h:mm A"
              :allowClear="false"
              separator="-"
              :showToday="false"
              :show-time="showTime"
              v-model="requestTime"
              @change="changeDate"
              :autoFocus="true"
              :inputReadOnly="true"
            />
          </div>
        </div>

        <div class="comments" style="margin-top: 16px">
          <div class="addBtn row" v-if="!addComment" @click="addComment = true">
            <svg-icon
              iconClass="add2"
              style="width: 15px; height: 15px"
            ></svg-icon>
            <span>{{ stringList.AddComments }}</span>
          </div>

          <div v-else>
            <div class="comments-textarea">
              <a-textarea
                v-model="comments"
                :placeholder="stringList.EnterCommentsCharacters"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 16px; padding-left: 24px">
          <div
            class="icon-button center"
            @click="clickOpen(4, ['damages', index, 'photo'])"
          >
            <svg-icon
              style="width: 28px; height: 24px"
              iconClass="photograph_normal"
            ></svg-icon>
            <span
              class="little-icon"
              :style="img?.length == 1 ? 'width:14px;height:14px' : ''"
              v-if="img?.length >= 1"
              >{{ img?.length > 1 ? img?.length : "" }}</span
            >
          </div>
        </div>
      </a-form>
    </div>

    <div class="footer">
      <van-button
        :spinning="true"
        class="button"
        @click="handleSubmit"
        native-type="submit"
        >{{ stringList.save }}</van-button
      >
    </div>

    <!-- 弹框 -->
    <a-modal
      v-model="visible"
      :style="{ display: !modalShow ? 'none' : '' }"
      :title="null"
      :footer="null"
      :closable="false"
      :width="320"
      :maskClosable="true"
      wrapClassName="all-modal"
      :bodyStyle="{ 'border-radius': '16px', background: '#fff' }"
      @cancel="visible = false"
    >
      <svg-icon
        class="modal-delete_x ceshi"
        style="width: 14px; height: 14px; fill: #767676"
        iconClass="delete_x"
        className="icons/svg/delete_x.svg"
        @click="visible = false"
      ></svg-icon>
      <!-- 编辑 -->
      <uploadImg
        ref="photo"
        v-model="img"
        @closed="visible = false"
        @open="visible = true"
      >
        <template #left>
          <svg-icon
            style="width: 11.5px; height: 22px; transform: rotate(180deg)"
            iconClass="right"
            className="icons/svg/right.svg"
          ></svg-icon>
        </template>
        <template #right>
          <svg-icon
            style="width: 11.5px; height: 22px"
            iconClass="right"
            className="icons/svg/right.svg"
          ></svg-icon>
        </template>
        <template #submit>
          <svg-icon
            style="width: 0.875rem; height: 0.875rem"
            iconClass="add_white"
            className="icons/svg/add_white.svg"
          ></svg-icon>
          <svg-icon
            style="width: 1.75rem; height: 1.5rem; margin-left: 10px"
            iconClass="photograph_white"
            className="icons/svg/photograph_white.svg"
          ></svg-icon>
        </template>
        <template #delete>
          <svg-icon
            style="width: 1.375rem; height: 1.375rem"
            iconClass="delete"
            className="icons/svg/delete.svg"
          ></svg-icon> </template
      ></uploadImg>
    </a-modal>

    <!-- 成功弹框 -->
    <Popup
      v-model="submitSuccessModal"
      round
      lock-scroll
      :closeOnClickOverlay="false"
      @closed="$router.go(-1)"
    >
      <div class="successModalContent">
        <div class="successModalContent-header center">
          {{ stringList.NewTicket }}
          <div class="closeIcon">
            <svg-icon
              @click="submitSuccessModal = false"
              style="width: 14px; height: 14px"
              iconClass="close-x"
            ></svg-icon>
          </div>
        </div>

        <div class="hint">{{ stringList.TicketSubmitted }}！</div>
        <div class="successModalContent-footer">
          <van-button
            :spinning="true"
            class="button"
            @click="submitSuccessModal = false"
            native-type="submit"
            >{{ stringList.OK }}</van-button
          >
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import uploadImg from "@/components/UploadImg.vue";
import Header from "@/components/Header.vue";
import { mapGetters } from "vuex";
import { getAction, postAction } from "@/api/manage";
import debounce from "lodash/debounce";
import moment from "moment-timezone";
import Vue from "vue";
import { Popup, Toast } from "vant";

export default {
  components: {
    Header,
    uploadImg,
    Popup,
  },
  data() {
    this.remoteMethod = debounce(this.remoteMethod, 800);
    return {
      showAddSpecial: false,

      roomNumber: "",
      form: this.$form.createForm(this, { name: "InspectRoom" }),
      serviceType: "",
      roomArray: [], // 房间信息
      photo: [],
      serviceOptions: [],
      departAll: [],
      fetching: false,
      addTime: false,
      requestTime: "",
      showTime: {
        format: "h:mm A",
        use12Hours: true,
      },

      addComment: false,
      comments: "",

      visible: false,
      modalShow: false,
      type: 0,
      img: [],

      departs: [],
      submitSuccessModal: false,
      first10Default: false,
      serviceKeyErrorMessage: "",
    };
  },
  computed: {
    ...mapGetters({
      stringList: "stringList",
      userInfo: "userInfo",
      language: "language",
    }),
  },
  created() {
    const { roomNumber } = this.$route.query;
    this.roomNumber = roomNumber;
    this.getRoomArray();
    this.getdepartByhotel();
    this.getServiceDept();
    this.remoteMethod("");
  },
  methods: {
    moment,
    checkInput($event) {
      if ($event.target.value.length > 100) {
        $event.target.value = $event.target.value.slice(0, 100);
        this.serviceKeyErrorMessage = this.stringList["SpecialRequest100"];
      } else {
        this.serviceKeyErrorMessage = "";
      }
      this.form.setFieldsValue({
        serviceKey: $event.target.value,
      });
    },
    async getRoomArray() {
      const { data } = await getAction(
        `/api/sys_admin/hotel/room/query2/guest/allmeeting`
      );
      this.roomArray = data;
    },
    async handleSubmit(e) {
      e.preventDefault();
      if (this.serviceKeyErrorMessage) return;
      this.form.validateFields(async (err, values) => {
        if (!err) {
          console.log("表单值:", values);

          const { hotelDeptId, roomNumber, serviceKey } = JSON.parse(
            JSON.stringify(values)
          );
          let { serviceType, requestTime, comments, img, showAddSpecial } =
            this;

          console.log("img=========", img);

          let arr = this.departs.filter((item) => {
            if (item.hotelDeptId === hotelDeptId) {
              return item;
            }
          });
          let hotelId = arr[0].hotelId;

          if (!requestTime) {
            requestTime = moment(new Date())
              .tz(Vue.ls.get("timeZone"))
              .format("MM/DD/YY h:mm A");
          }
          console.log("requestTime=========", requestTime);

          var b = moment.tz(
            moment(requestTime).format("YYYY-MM-DD HH:mm"),
            Vue.ls.get("timeZone")
          );

          let a = moment(new Date())
            .tz(Vue.ls.get("timeZone"))
            .format("MM/DD/YY h:mm A");

          let createTime = moment.tz(
            moment(a).format("YYYY/MM/DD HH:mm"),
            Vue.ls.get("timeZone")
          );

          let params = {
            requestTime: b.utc().format(),
            createTime: moment.utc().format(),
            // createTime: createTime.utc().format(),
            notes: comments,
            orderType: "internal",
            hotelId,
            hotelDeptId,
            roomNumber,
            serviceKey,
            serviceType,
            img: img && img.length ? img.map((item) => item.url).join(",") : "",
          };

          try {
            Toast.loading({
              message: this.stringList.Loading,
              forbidClick: true,
              duration: 0,
            });

            const { status, msg, data } = await postAction(
              "/api/common/hotel/data/order/create",
              params
            );
            if (status == 0) {
              this.submitSuccessModal = true;
            } else {
              this.$message.error(msg);
            }
          } finally {
            Toast.clear();
          }
        }
      });
    },
    filterOption(input, option) {},

    async remoteMethod(value) {
      // if (value !== "") {
      this.fetching = true;
      const { data } = await getAction(
        `/api/app/current_user/keywordsByLanguage/${value || null}/${
          this.language == "zh" ? "zh-CN" : this.language
        }`
      );
      // const { data } = await getAction(
      //   `/api/app/current_user/pc/keywords/${value}`
      // );
      this.serviceOptions = data.map((item) => {
        return {
          ...item,
          en: item.keyword,
        };
      });
      console.log("serviceOptions", this.serviceOptions);
      if (this.serviceOptions.length == 1) {
        this.form.setFieldsValue({
          serviceKey: this.serviceOptions[0].serviceType,
        });
        this.serviceType = this.serviceOptions[0].serviceType;

        let ds = this.departAll.filter(
          (d) => d.hotelDeptId === this.serviceOptions[0].hotelDeptId
        );
        if (ds.length > 0) {
          this.form.setFieldsValue({
            hotelDeptId: this.serviceOptions[0].hotelDeptId,
          });
        } else {
          this.form.setFieldsValue({
            hotelDeptId: "",
          });
        }
      }
      this.fetching = false;
      // } else {
      //   this.serviceOptions = [];
      // }
    },

    async changeServiceKey(value) {
      let arr = this.serviceOptions.filter((item) => {
        if (item.keyword == value) {
          return item;
        }
      });
      this.serviceType = arr[0].serviceType;

      let ds = this.departAll.filter(
        (d) => d.hotelDeptId === arr[0].hotelDeptId
      );
      if (ds.length > 0) {
        this.form.setFieldsValue({
          hotelDeptId: arr[0].hotelDeptId,
        });
      } else {
        this.form.setFieldsValue({
          hotelDeptId: "",
        });
      }
    },

    async onChange(e) {
      this.showAddSpecial = !this.showAddSpecial;
      this.form.setFieldsValue({
        serviceKey: "",
      });
      this.serviceType = "";
    },

    addTimes() {
      this.requestTime = moment(new Date())
        .tz(Vue.ls.get("timeZone"))
        .format("MM/DD/YY h:mm A");
      this.addTime = true;
    },
    changeDate(date, dateString) {
      console.log(date, dateString);
      let date1 = dateString.split(" ")[0];

      let time = moment(new Date())
        .tz(Vue.ls.get("timeZone"))
        .format("YYYY/MM/DD h:mm A");
      const compareTimes = (timeStr1, timeStr2) => {
        console.log("timeStr1", timeStr1, "timeStr2", timeStr2);
        // 解析两个时间字符串
        const time1 = moment.tz(
          timeStr1,
          "MM/DD/YY h:mm A",
          Vue.ls.get("timeZone")
        );
        const time2 = moment.tz(
          timeStr2,
          "YYYY-MM-DD h:mm A",
          Vue.ls.get("timeZone")
        );

        // 验证时间是否有效
        if (!time1.isValid() || !time2.isValid()) {
          throw new Error("Invalid time string(s)");
        }

        // 比较结果
        if (time1.isBefore(time2)) {
          return -1; // time1 早于 time2
        } else if (time1.isAfter(time2)) {
          return 1; // time1 晚于 time2
        } else {
          return 0; // 两者相同
        }
      };

      if (compareTimes(dateString, time) == 1) {
        if (!this.first10Default) {
          this.requestTime = date1 + " " + "10:00 AM";
          this.first10Default = true;
        } else {
          this.requestTime = dateString;
        }
      } else {
        this.requestTime = time;
      }
    },

    clickOpen(type, nameList) {
      this.type = type;
      this.visible = true;
      this.modalShow = true;
      if (type == 4 && (!this.img || this.img.length == 0)) {
        this.modalShow = false;
        this.$nextTick(() => {
          this.$refs.photo.uploadImg();
        });
      }
    },

    async getdepartByhotel() {
      const { data } = await getAction(
        `/api/common/hotel/data/dept/by_hotel/${this.userInfo.hotelNo}`
      );
      this.departAll = data.map((item) => {
        return { ...item, ...JSON.parse(item.deptName2) };
      });
    },

    async getServiceDept() {
      const { data } = await getAction(
        `/api/common/hotel/data/service_dept/by_hotel/${this.userInfo.hotelNo}`
      );
      this.departs = data;
    },
  },
};
</script>
<style lang="scss">
.ant-select-dropdown-menu-item {
  color: #050101 !important;
  font-size: 16px;
  text-align: left !important;
}
</style>
<style lang="scss" scoped>
.newTicket {
  flex: 1;
  background-color: #f2f2f2;
  overflow-y: auto;
}

.content {
  min-height: 374px;
  padding: 24px 3.75rem;
  opacity: 1;
  background: #ffffff;

  .content-title {
    height: 26px;
    opacity: 1;
    font-family: Arial;
    font-size: 22px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    color: #5a578c;
    margin-bottom: 32px;
  }
}

.formItem {
  display: flex;
  margin: 12px 0 12px;
  /deep/.ant-form-item-label {
    width: 84px;
    padding-bottom: 0 !important;

    label {
      font-size: 16px;
      font-weight: normal;
      color: #050101;
      line-height: 40px !important;
    }
  }

  /deep/.ant-form-item-control-wrapper {
    flex: 1;
    overflow: hidden;
  }

  /deep/.ant-form-item-required::before {
    display: none !important;
  }

  /deep/.ant-select {
    width: 100% !important;

    .ant-select-selection {
      height: 40px !important;
      background: #f2f2f2 !important;

      .ant-select-selection__rendered {
        line-height: 40px !important;
        justify-content: flex-start;

        .ant-select-selection-selected-value {
          font-size: 16px;
          font-weight: normal;
          color: #000000;
        }
      }

      .ant-select-selection__placeholder {
        color: #767676;
        font-size: 16px;
        text-align: left !important;
      }
    }
  }

  textarea {
    background-color: #f2f2f2 !important;
  }
  .error-message {
    opacity: 1;
    font-family: Arial;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    color: #df714f;
    line-height: 18px;
  }

  /deep/.has-error {
    position: relative;
    .ant-form-explain {
      font-family: Arial;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 6px;
      letter-spacing: 0em;
      display: flex;
      color: #df714f;
      justify-content: center;
    }

    .ant-select-selection,
    .ant-input {
      box-shadow: none;
      background: #fee0d6 !important;
      border: 1px solid #df714f !important;
    }

    .ant-select-selection__placeholder,
    .ant-cascader-picker-label {
      color: #df714f !important;
    }

    input::placeholder {
      color: #df714f !important;
    }
  }

  /deep/.ant-select-disabled {
    background: #f2f2f2 !important;

    .ant-select-selection {
      background: #f2f2f2 !important;
    }
  }
}

/deep/.ant-calendar-picker {
  width: 100% !important;

  .ant-input {
    height: 40px !important;
    // padding-left: 24px;
    background-color: #f2f2f2 !important;
  }

  .ant-cascader-picker-label {
    padding-left: 24px;
    text-align: left !important;
    font-size: 16px;
    font-weight: normal;
    color: #000000;
  }
}

.comments-textarea {
  textarea {
    background-color: #f2f2f2 !important;
  }
}

.footer {
  margin: 24px auto 32px;
  .button {
    width: 200px;
    height: 40px;
    border-radius: 8px;
    opacity: 1;
    background: #ff6600;
    font-family: Arial;
    font-size: 16px;
    font-weight: 700;
    line-height: 18.72px;
    text-align: center;
    // display: flex;
    // align-items: center;
    letter-spacing: 0em;
    color: #ffffff;
    border: 0;
  }
}

.RequestCheck {
  /deep/.ant-checkbox-wrapper {
    .ant-checkbox-inner {
      border-color: #666 !important;
    }
    span {
      /* 自动布局子元素 */
      font-size: 16px;
      font-weight: normal;
      line-height: 18px;
      color: #101010 !important;
    }

    .ant-checkbox-checked {
      .ant-checkbox-inner {
        background-color: #ff6600 !important;
      }
    }

    .ant-checkbox-checked::after {
      border: 1px solid #ff6600;
    }
  }
}

.comments {
  .addBtn {
    span {
      font-family: Arial;
      font-size: 16px;
      color: #101010;
      margin-left: 9px;
    }
  }

  .title {
    font-family: Arial;
    font-size: 16px;
    color: #101010;
    line-height: 46px;
    text-align: left;
  }

  &-textarea {
    /deep/.ant-input {
      border: 1px solid #afafaf;
      border-radius: 6px !important;
      // background: #f2f2f2 !important;
    }
  }
}

.comments {
  .addBtn {
    span {
      font-family: Arial;
      font-size: 16px;
      color: #101010;
      margin-left: 9px;
    }
  }

  .title {
    font-family: Arial;
    font-size: 16px;
    color: #101010;
    line-height: 46px;
    text-align: left;
  }

  &-textarea {
    /deep/.ant-input {
      border: 1px solid #afafaf;
      border-radius: 6px !important;
      // background: #f2f2f2 !important;
    }
  }
}

.icon-button {
  flex-shrink: 0;
  border-radius: 12px;
  position: relative;

  .little-icon {
    position: absolute;
    top: -6px;
    right: -8px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    opacity: 1;
    font-family: Arial;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    background: #ff6600;
    border: 2px solid #ffffff;
  }
}

.successModalContent {
  width: 320px;
  height: 220px;
  padding: 0px 0px 32px 0px;
  border-radius: 12px;
  overflow: hidden;

  &-header {
    height: 56px;
    padding: 16px 16px 16px 20px;
    background: #f2f2f2;

    font-family: Arial;
    font-size: 22px;
    font-weight: bold;
    color: #5a578c;
    position: relative;

    .closeIcon {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .hint {
    font-family: Arial;
    font-size: 18px;
    font-weight: normal;
    line-height: 22px;
    text-align: center;
    color: #101010;
    margin-top: 28px;
  }

  &-footer {
    margin: 28px auto 0;
    .button {
      width: 140px;
      height: 48px;
      border-radius: 8px;
      opacity: 1;
      background: #ff6600;
      font-family: Arial;
      font-size: 16px;
      font-weight: 700;
      line-height: 18.72px;
      text-align: center;
      letter-spacing: 0em;
      color: #ffffff;
      border: 0;
    }
  }
}
</style>
